import React, { Component, useEffect, useState } from 'react'; 
import Image from 'next/image';
import "aos/dist/aos.css";
import AOS from 'aos';
import { useRouter } from 'next/router';
import IMAGES from '@/public/assets/img';

const Banner1=(props)=> {
    const router = useRouter();
    const [mWidth, setMWidth] = useState(0)
    const handleWindowResize = () => {
      setMWidth(window.innerWidth);
    }
    useEffect(() => {
        AOS.init();
      }, []);
      const openForm = () => {
        props.download();
        // handleDownloadSolutionBannerClick();
    }
      
    return (
        <section className={props.classes} style={{background:`url(${IMAGES.POFinance.bgBanner.src})`, backgroundSize:'cover', backgroundRepeat:'no-repeat'}}>
                    <div className='container flex px-3 lg:px-3  xm:px-2'>
                        <div className='flex w-full sm:flex-col items-center min-h-[600px] sm:py-10 sm:min-h-[450px] h-full sm:h-auto'>
                            <div className='w-3/5 md:w-1/2 sm:w-full' data-aos="fade-up" data-aos-duration="500" data-aos-once="true" >
                                <div>
                                    <h1 className='text-base text-brand font-medium mb-xsp sm:mt-sp-100'>
                                    {props.title}</h1>
                                        <h2 className='text-heading2 w-full max-w-[555px] block text-brand font-bold mb-3'>
                                        {props.subtitle}
                                        </h2>
                                    <p className='text-base w-full max-w-[555px] text-secondary'>{props.paratitle}</p>
                                    <button className='mt-5 bg-brand text-white text-sm py-[13px] px-[20px] font-semibold rounded-xl flex items-center bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-md transition-all duration-300 ease-in-out hover:from-[#0363C4] hover:to-[#022B5C]' onClick={openForm}>
                                    {props.cta} <span className='align-middle ml-[8px]'><svg xmlns="https://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="none" d="M0 0h24v24H0z"/><path fill="white" d="M16 2l5 5v14.008a.993.993 0 0 1-.993.992H3.993A1 1 0 0 1 3 21.008V2.992C3 2.444 3.445 2 3.993 2H16zm-3 10V8h-2v4H8l4 4 4-4h-3z"/></svg></span>
                                    </button>
                                </div>
                            </div>
                            <div className='w-2/5 md:w-1/2 sm:w-full self-end' data-aos="fade-up" data-aos-duration="500" data-aos-once="true">
                                <div className={props.imageclasses}>
                               
                                  <Image priority={true} fetchPriority='high' className='w-full max-w-[600px] sm:w-full sm:mt-4 sm:max-w-full' src={props.bannerimg} alt="Credlix for all your Invoices" width={500} height={500}/>
                                  
                                </div>
                            </div>
                        </div>
                    </div>
        </section>
      
        
    )
}

export default Banner1;